import React from 'react';
import BoxedArrowRight from '../../assets/images/boxed-arrow-right.svg';
import type { Category as CategoryType, AdviceResponse } from '../../types/product';

interface Props {
  category: CategoryType;
  allowedProducts: string[];
  adviceResponseObject: AdviceResponse;
  onClick: () => void;
}

const CategoryNew = ({ category, allowedProducts, adviceResponseObject, onClick }: Props) => {
  const productsToDisplay = category.products.filter((pid) => allowedProducts.includes(pid));
  if (productsToDisplay.length <= 0) return <></>;

  const firstProduct = adviceResponseObject.products[productsToDisplay[0]];

  return (
    <div
      className="border-2 border-solid border-[rgba(249,235,242,1)] rounded-lg p-4 hover:border-[rgba(139,37,96,1)] hover:shadow-lg transition-shadow flex flex-col justify-between bg-white cursor-pointer min-h-[280px] rounded-[20px]"
      onClick={onClick}
    >
      {firstProduct?.featured_image ? (
        <img src={firstProduct.featured_image} alt={firstProduct.name} className="mb-4 rounded w-full object-contain max-h-[140px]" />
      ) : (
        <div className="h-32 bg-gray-100 mb-4 rounded flex items-center justify-center">
          <span className="text-gray-400">Geen afbeelding</span>
        </div>
      )}
      {category.name && (
        <div className="flex items-center justify-between mt-auto">
          <h2 className="text-lg font-bold break-words" style={{ maxWidth: '80%', whiteSpace: 'normal', overflow: 'hidden', display: '-webkit-box', wordBreak: 'break-word', hyphens: 'auto' }}>
            {category.name}
          </h2>
          <div className="relative self-end p-1">
            <img src={BoxedArrowRight} alt="Arrow" className="w-8 h-8" />
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryNew;
